module.exports = __webpack_public_path__ + "static/media/18.86b8dc4f.jpg";